import commonPostTypeConfig from '../../common/postTypes/image'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'image',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
